export enum MaterialPurpose {
	Production =10,
	Fixings = 20,
	Material = 30,
	Transport = 40,
	Other = 100
}